// Сохранение файла выгрузки в браузере: журнал сразу (до 10 000 записей) и файл из «Моих
// выгрузок» (002) — одним путём.
import { XLSX_CONTENT_TYPE } from '@kp/contracts';

/** Скачивание файла выгрузки: имя «журнал-2026-10-14.xlsx». */
export function saveFile(bytes: ArrayBuffer, name: string): void {
  const url = URL.createObjectURL(new Blob([bytes], { type: XLSX_CONTENT_TYPE }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
